import React, { useState, useContext, useEffect } from "react";
import { HotelContext } from "context/HotelContext";
import { useAuth } from "react-oidc-context";
import StatCard from "component/Stat_card";
import droplet from "../img/droplet.svg";
import cloud from "../img/Cloud.svg";
import money from "../img/money.svg";
import Translation from "utils/Translation";
import BreadCrumb from "component/Breadcrumb";
import { monthsGraph } from "../utils/Translation";

const DashboardGM = () => {
  const keycloak = useAuth();
  const { hId, lang } = useContext(HotelContext);
  const [stats, setStats] = useState(null);
  const [actionNames, setActionNames] = useState([]);
  const [rewardNames, setRewardNames] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [noDataAvailable, setNoDataAvailable] = useState(false);

  const currentMonthIndex = new Date().getMonth();
  const currentMonthLabel = monthsGraph[lang][currentMonthIndex];

  const fetchStatsByHotel = () => {
    if (!keycloak.isAuthenticated || !keycloak.user?.access_token) {
      setHasError(true);
      setLoading(false);
      return;
    }

    setLoading(true);
    setNoDataAvailable(false);
    fetch(`/api/hotels/${hId}/dashboard-info?lang=${lang}`, {
      method: "get",
      headers: {
        Authorization: "Bearer " + keycloak.user.access_token,
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-front-token": "Bs#PSQyhy)!y9Ti{",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success === "OK") {
          setStats(data.dashboardStats);

          console.log(data.dashboardStats);

          setActionNames(data.dashboardStats.actionNames || []);
          setRewardNames(data.dashboardStats.rewardNames || []);
          console.log(data.dashboardStats);
          setHasError(false);
        } else {
          setHasError(true);
          console.error("Error fetching stats:", data.message);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setHasError(true);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (keycloak.isAuthenticated && keycloak.user && hId) {
      fetchStatsByHotel();
    }
  }, [keycloak.isAuthenticated, hId]);

  return (
    <div>
      <BreadCrumb text={<Translation tag="Dashboard_title" />} />
      <h1 className="h1-page">
        <Translation tag={"Dashboard_title"} />
      </h1>
      <p className="cleaning-description">{/* <Translation tag={"DashboardGM_text"} /> <strong>{currentMonthLabel}</strong> */}</p>

      {loading ? (
        <p>Chargement des stats...</p>
      ) : hasError ? (
        <p>Erreur lors du chargement des données.</p>
      ) : !stats ? (
        <p>Aucune information disponible pour le moment.</p>
      ) : (
        <>
          <div className="dashboard-grid">
            {/* Bloc 1 - Vue Globale */}
            <div className="dashboard-card">
              <h3 className="border_bottom text-center">
                <Translation tag="Dashboard_Global_Title" />
              </h3>
              <p className="main-stat">
                <strong>{stats.totalUniqueUsers}</strong>
                <span className="stat-label">
                  <Translation tag="Dashboard_Global_Users" />
                </span>
              </p>
              <p className="main-stat">
                <strong>{stats.totalInteractions}</strong>
                <span className="stat-label">
                  <Translation tag="Dashboard_Global_Interactions" />
                </span>
              </p>
            </div>

            {/* Bloc 2 - Actions RSE */}
            <div className="dashboard-card">
              <h3 className="border_bottom text-center">
                <Translation tag="Actions" />
              </h3>
              <div className="dashboard-card-content">
                <p className="main-stat">
                  <strong>{stats.totalActionsCompleted}</strong>
                  <span className="stat-label">
                    <Translation tag="Dashboard_Actions_Completed" />
                  </span>
                </p>
                <p className="main-stat">
                  <strong>{stats.totalGreenMilesFromActions} GM</strong>
                  <span className="stat-label">
                    <Translation tag="Dashboard_Actions_GM" />
                  </span>
                </p>
              </div>
            </div>

            {/* Bloc 2 - Récompenses */}
            <div className="dashboard-card">
              <h3 className="border_bottom text-center">
                <Translation tag="Récompenses" />
              </h3>
              <div className="dashboard-card-content">
                <p className="main-stat">
                  <strong>{stats.totalRewardsClaimed}</strong>
                  <span className="stat-label">
                    <Translation tag="Dashboard_Rewards_Claimed" />
                  </span>
                </p>
                <p className="main-stat">
                  <strong>{stats.totalGreenMilesFromRewards} GM</strong>
                  <span className="stat-label">
                    <Translation tag="Dashboard_Rewards_GM" />
                  </span>
                </p>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default DashboardGM;
